import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=8490fcda&scoped=true&"
import script from "./Footer.js?vue&type=script&lang=js&"
export * from "./Footer.js?vue&type=script&lang=js&"
import style0 from "./Footer.scss?vue&type=style&index=0&id=8490fcda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8490fcda",
  null
  
)

export default component.exports